import { useRef } from 'react';
import Loader from '../shared/Loader';

const ChatAudioContent = ({ src, onPlay, loading }) => {
  const audioRef = useRef(null);

  const handlePlay = async () => {
    if (!onPlay || loading) return;
    const freshSrc = await onPlay();
    if (freshSrc && audioRef.current && audioRef.current.src !== freshSrc) {
      audioRef.current.src = freshSrc;
      audioRef.current.load();
      try {
        await audioRef.current.play();
      } catch (err) {
        // Browser may block autoplay; user can click play again
        audioRef.current.load();
      }
    }
  };

  return (
    // <div style={{ ...styles.container, ...style }}>
    <div style={styles.container}>
      <audio
        ref={audioRef}
        // controls={!loading}
        controls
        src={src}
        preload="metadata"
        onPlay={handlePlay}
        style={styles.audio}
      />
      {loading && (
        <div style={styles.loaderOverlay}>
          <Loader />
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    position: 'relative',
    display: 'inline-block',
    width: 280
  },
  audio: {
    display: 'block',
    width: '100%'
  },
  loaderOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: 4
  }
};

export { ChatAudioContent };
